import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertDateTimeToTime',
})
export class ConvertDateTimeToTimePipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      let val = new Date(value).toTimeString().split(' ')[0].slice(0, 5);
      if (val) {
        return val;
      } else {
        return 'Invalid Time';
      }
    } else {
      return 'Time not found';
    }
  }
}
